import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ProductInfo, PRODUCT_TYPE} from '../../../models/product';
import {TABLE_SELECTION_MODE} from '../../../models/table';
import {Observable, Subject} from 'rxjs';
import {map, shareReplay, takeUntil, tap} from 'rxjs/operators';
import {ProductService} from '../../../product-view-module/services/product.service';
import {Alert} from '@bmc-ux/adapt-angular';
import {TABLE_TYPE} from '../../../models/column-config';


interface MasterProductInfo extends ProductInfo {
  isDisabled: boolean;
}

@Component({
  selector: 'app-all-bmc-products-table',
  templateUrl: './all-bmc-products-table.component.html',
  styleUrls: ['./all-bmc-products-table.component.sass']
})
export class AllBmcProductsTableComponent implements OnInit, OnDestroy {
  @Input() public assignedProducts: ProductInfo[];
  @Input() public masterTableTitle: string;

  @Output() public addProducts: EventEmitter<ProductInfo[]> = new EventEmitter();

  public TABLE_TYPE: typeof TABLE_TYPE = TABLE_TYPE;
  public TABLE_SELECTION_MODE = TABLE_SELECTION_MODE;
  public isGridLoading = false;

  public products$: Observable<MasterProductInfo[]>;
  public selectedProducts: MasterProductInfo[] = [];

  public alertConfig: Alert = {
    variant: 'danger',
    type: 'inline',
    dismissible: true
  };

  private onComponentDestroyed$: Subject<void> = new Subject();

  constructor(private productService: ProductService) { }

  ngOnInit(): void {
    this.isGridLoading = true;
    this.products$ = this.productService.getProducts(`${PRODUCT_TYPE.PRODUCT},${PRODUCT_TYPE.SERVICE_PACK},${PRODUCT_TYPE.SUITE}`)
      .pipe(
        tap((): void => {
          this.isGridLoading = false;
        }),
        map((products: ProductInfo[]): MasterProductInfo[] => {
          return products.map((curProduct: ProductInfo): MasterProductInfo => ({
            ...curProduct,
            isDisabled: this.assignedProducts.some((curAssignedProduct: MasterProductInfo): boolean => curAssignedProduct.id === curProduct.id)
          }));
        }),
        shareReplay(1),
        takeUntil(this.onComponentDestroyed$)
      );
  }

  ngOnDestroy(): void {
    this.onComponentDestroyed$.next();
    this.onComponentDestroyed$.complete();
    this.onComponentDestroyed$.unsubscribe();
  }

  public selectedProduct(selectedProducts: MasterProductInfo[]): void {
    this.selectedProducts = selectedProducts;
  }

  public onApplyAddingNewProducts(): void {
    this.addProducts.emit(this.selectedProducts);
  }

  public onCancelAddingNewProducts(): void {
    this.addProducts.emit([]);
  }

  public disabledRowSelectionResolver(product: MasterProductInfo): boolean {
    return product.isDisabled;
  }
}
